import React, { useState } from "react";

import Container from "@material-ui/core/Container";
import ApplicationPanel from "../../application/ApplicationPanel";
import ApplicationHeader from "../../application/ApplicationHeader";
import ContentIngestionJobBrowse from "./ContentIngestionJobBrowse";
import { useDiscoverySearch } from "./processingDiscoveryServices";
import { Route, useHistory, useRouteMatch } from "react-router-dom";
import withAuthorization from "../../auth/withAuthorization";
import ContentIngestionJobDetailView from "./ContentIngestionJobDetailView";
import { pickBy } from "ramda";
import { notBlank } from "../../util/ext";
import ContentIngestionChunkDetailView from "./ContentIngestionChunkDetailView";

const generateStartDate = () => {
  const adjustment = 1;

  const currDate = new Date();
  currDate.setDate(currDate.getDate() - adjustment);
  currDate.setUTCHours(0, 0, 0, 0);
  return currDate;
};

const AuthorizedRoute = withAuthorization(Route);

const ContentIngestionReportingView = () => {
  const { path } = useRouteMatch();
  const history = useHistory();

  const initialSearchState = {
    orderBy: null,
    orderDirection: "asc",
    startDate: generateStartDate(),
    endDate: new Date(),
  };

  const [searchState, setSearchState] = useState(initialSearchState);
  const searchResults = useDiscoverySearch(
    pickBy(notBlank, {
      startDate: searchState.startDate,
      endDate: searchState.endDate,
      filename: searchState.filename,
      status: searchState.status,
    }),
  );

  return (
    <Container id="metadata-file-discovery" disableGutters>
      <ApplicationHeader />

      <AuthorizedRoute
        exact
        path={`${path}/:jobId/:chunkId`}
        roles={["ROLE_ADMIN"]}
      >
        <ApplicationPanel id="application-panel-chunk-detail">
          <ContentIngestionChunkDetailView
            onCancel={() => history.push(`${path}`)}
          />
        </ApplicationPanel>
      </AuthorizedRoute>

      <AuthorizedRoute exact path={`${path}/:jobId`} roles={["ROLE_ADMIN"]}>
        <ApplicationPanel id="application-panel-job-detail">
          <ContentIngestionJobDetailView
            onCancel={() => history.push(`${path}`)}
          />
        </ApplicationPanel>
      </AuthorizedRoute>

      <Route exact path={path}>
        <ApplicationPanel id="application-panel-content-ingestion-report">
          <ContentIngestionJobBrowse
            searchState={searchState}
            onSearchStateChange={state => setSearchState(state)}
            searchResults={searchResults}
          />
        </ApplicationPanel>
      </Route>
    </Container>
  );
};

export default ContentIngestionReportingView;
